module.exports = __webpack_public_path__ + "img/477319-71-4.e466cf6c.png";